import { AppBar, Box, Button, Container, Toolbar } from '@mui/material';
import LogoutIcon from '@mui/icons-material/LogoutOutlined';
import { Link as RouterLink, Outlet, useLoaderData, useNavigate } from 'react-router';
import toast from 'react-hot-toast';
import { Brand } from '@/components/Brand';
import { ThemeToggle } from '@/components/ThemeToggle';
import { AuroraBackground } from '@/components/AuroraBackground';
import { api } from '@/lib/api';
import type { UserProfile } from '@/auth/session';

export default function AppLayout() {
  const user = useLoaderData() as UserProfile;
  const navigate = useNavigate();

  async function logout() {
    try {
      await api.post('/api/auth/logout');
    } catch {
      // The session cookie may still be live — warn instead of silently
      // pretending we logged out, but still leave the console view.
      toast.error('ອອກຈາກລະບົບບໍ່ສຳເລັດ — ຄຸກກີ້ອາດຍັງໃຊ້ໄດ້, ລອງໃໝ່');
    }
    navigate('/login');
  }

  return (
    <Box sx={{ minHeight: '100dvh' }}>
      <AuroraBackground />
      <AppBar position="sticky" elevation={0} color="transparent"
        sx={(t) => ({
          backdropFilter: 'blur(14px)',
          borderBottom: '1px solid',
          borderColor: 'divider',
          background: 'rgba(255,255,255,0.5)',
          ...t.applyStyles('dark', { background: 'rgba(10,14,20,0.5)' }),
        })}>
        <Toolbar sx={{ gap: 2 }}>
          <Brand />
          <Button component={RouterLink} to="/" color="inherit">Dashboard</Button>
          <Button component={RouterLink} to="/companies" color="inherit">ບໍລິສັດ</Button>
          <Button component={RouterLink} to="/company-taxes" color="inherit">ບໍລິສັດ (ພາສີ)</Button>
          <Button component={RouterLink} to="/company-information" color="inherit">ຂໍ້ມູນບໍລິສັດ</Button>
          {/* Both admin-only on the server; showing them to anyone else just hands them a 403. */}
          {user?.role === 'admin' && (
            <>
              <Button component={RouterLink} to="/module-requests" color="inherit">ຄຳຂໍເປີດໂມດູນ</Button>
              <Button component={RouterLink} to="/users" color="inherit">ຜູ້ໃຊ້</Button>
            </>
          )}
          <Box sx={{ flexGrow: 1 }} />
          <ThemeToggle />
          <Button onClick={logout} startIcon={<LogoutIcon />} color="inherit">
            {user?.username ? `${user.username} · ອອກ` : 'ອອກ'}
          </Button>
        </Toolbar>
      </AppBar>
      <Container maxWidth={false} sx={{ py: 4, px: { xs: 2, sm: 3, md: 4 } }}>
        <Outlet />
      </Container>
    </Box>
  );
}
